import { Fragment } from 'react';
import { Box, H1 } from '../../components';
import {
  settings_system,
  profilePageQuery_profilePage,
  PenaltyStatus
} from '../../core-types';
import { Penalties } from './Penalties';
import { CurrentSubscription } from './CurrentSubscription';
import { PayUnpaidOrders } from '../UnpaidOrders/PayUnpaidOrders';
import { SystemPartners } from '../Partners/SystemPartners';
import { useCurrentUser } from '../../lib/core/useCurrentUser';

const Subscription = ({
  profilePage,
  system
}: {
  profilePage: profilePageQuery_profilePage;
  system: settings_system;
}) => {
  const { currentUser } = useCurrentUser();
  if (!currentUser) {
    return null;
  }
  return (
    <Fragment>
      <Box mb={4} data-testid="Profile__Subscription">
        <H1 textAlign="center" mt={6} mb={6}>
          {profilePage.heading &&
            profilePage.heading.replace('{userName}', currentUser.name || '')}
        </H1>
        <PayUnpaidOrders />
        <CurrentSubscription />
        {currentUser.penaltyStatus &&
          currentUser.penaltyStatus !== PenaltyStatus.none && (
            <Penalties
              system={system}
              penaltyStatus={currentUser.penaltyStatus}
            />
          )}
        <SystemPartners />
      </Box>
    </Fragment>
  );
};

export default Subscription;
